import * as React from 'react';
import ResponsivePagination from 'react-responsive-pagination';

const PagerWrapper = ({
  currentPage,
  totalPages,
  onPageChange,
  maxWidth,
}: {currentPage: number, totalPages: number, onPageChange: (page: number) => void, maxWidth?: number}) => {
  return (
    <div className="row pager-box align-items-center">
      <ResponsivePagination
        total={totalPages || 0}
        current={currentPage || 0}
        onPageChange={(page) => onPageChange(page)}
        maxWidth={maxWidth}
      />
    </div>
  );
};

export default PagerWrapper;
